import React from 'react';
import { useNavigate } from 'react-router-dom';
import PrivacyModal from '../components/PrivacyModal';

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <main className="min-h-screen bg-[#0d0916]">
      <PrivacyModal open onClose={() => navigate('/login')} />
    </main>
  );
}
